import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode } from 'react';
import styled, { Interpolation } from 'styled-components';

interface ModalTitleProps {
    children?: ReactNode;
    className?: string;
    styles?: Interpolation<CSSProperties>;
}

const StyledModalTitle = styled.div<{ styles?: Interpolation<CSSProperties> }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    ${({ styles }) => styles};
    ${({ theme: { typography, isMobile } }) => `
        padding: ${isMobile ? '16px' : '16px 24px'};
        font-size: ${
            isMobile ? typography.size.mobile.heading.h6 : typography.size.desktop.heading.h6
        };
        font-weight: ${typography.weight.medium};
    `};
`;

const ModalTitle: FC<ModalTitleProps> = ({ children, styles, className }) => {
    return (
        <StyledModalTitle className={classNames('modal-title', className)} styles={styles}>
            {children}
        </StyledModalTitle>
    );
};

export default ModalTitle;
